var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAddImages = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2222 1H2.77778C1.79594 1 1 1.79594 1 2.77778V15.2222C1 16.2041 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.2041 17 15.2222V2.77778C17 1.79594 16.2041 1 15.2222 1Z",
    stroke: "#7D86A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.889 7.22221C6.62538 7.22221 7.22233 6.62526 7.22233 5.88888C7.22233 5.1525 6.62538 4.55554 5.889 4.55554C5.15262 4.55554 4.55566 5.1525 4.55566 5.88888C4.55566 6.62526 5.15262 7.22221 5.889 7.22221Z",
    stroke: "#7D86A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 11.6667L12.5556 7.22229L7.66672 12.1112L2.77783 17.0001",
    stroke: "#7D86A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2222 8.99988H10.7778C9.79594 8.99988 9 9.79582 9 10.7777V23.2221C9 24.2039 9.79594 24.9999 10.7778 24.9999H23.2222C24.2041 24.9999 25 24.2039 25 23.2221V10.7777C25 9.79582 24.2041 8.99988 23.2222 8.99988Z",
    fill: "#F4F6FB",
    stroke: "#7D86A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.889 15.222C14.6254 15.222 15.2223 14.625 15.2223 13.8886C15.2223 13.1523 14.6254 12.5553 13.889 12.5553C13.1526 12.5553 12.5557 13.1523 12.5557 13.8886C12.5557 14.625 13.1526 15.222 13.889 15.222Z",
    fill: "#F4F6FB",
    stroke: "#7D86A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 19.6665L20.5554 15.222L10.7776 24.9998",
    fill: "#F4F6FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 19.6665L20.5554 15.222L10.7776 24.9998",
    stroke: "#7D86A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddImages, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add_images.8af10d12.svg";
export { ForwardRef as ReactComponent };